/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RetryParams
 */
export class RetryParams {
    /**
     *
     * @type {boolean}
     * @memberof RetryParams
     */
    retryActive?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof RetryParams
     */
    isRetryAvailable?: boolean;
    /**
     *
     * @type {number}
     * @memberof RetryParams
     */
    retryExpirationDays?: number;
    /**
     *
     * @type {number}
     * @memberof RetryParams
     */
    retryDiscountAmount?: number;
    /**
     *
     * @type {string}
     * @memberof RetryParams
     */
    retryDiscountType?: RetryParamsRetryDiscountTypeEnum;
    /**
     *
     * @type {string}
     * @memberof RetryParams
     */
    retryDiscountFrom?: RetryParamsRetryDiscountFromEnum;
    /**
     *
     * @type {number}
     * @memberof RetryParams
     */
    retryLimit?: number;
    /**
     *
     * @type {string}
     * @memberof RetryParams
     */
    retryInitialPlanReference?: string;
    /**
     *
     * @type {string}
     * @memberof RetryParams
     */
    retryNextPlanReference?: string;
    /**
     *
     * @type {number}
     * @memberof RetryParams
     */
    retryCounter?: number;
}

/**
 * @export
 * @enum {string}
 */
export enum RetryParamsRetryDiscountTypeEnum {
    Fixed = 'Fixed',
    Percent = 'Percent',
}
/**
 * @export
 * @enum {string}
 */
export enum RetryParamsRetryDiscountFromEnum {
    OriginalPrice = 'OriginalPrice',
    PaidPrice = 'PaidPrice',
}
